module.exports = __webpack_public_path__ + "static/img/14.a1c52da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/14.png
// module id = 1XgX
// module chunks = 0